import type { DocumentUploaderItem } from '@app/shared/types/sf-data'
import type {
  LastOCRRequestParamsByAccountId,
  LastOCRRequestParams,
  ProposedDocument,
} from './types'
import { ExtraDocumentLinkTypes } from './types'

export const isLastOCRRequestParamsByAccountId = (
  params: LastOCRRequestParams
): params is LastOCRRequestParamsByAccountId => {
  return (params as LastOCRRequestParamsByAccountId).accountId !== undefined
}

export const isProposedDocument = (
  doc: DocumentUploaderItem | ProposedDocument
): doc is ProposedDocument => {
  return doc.linkType === ExtraDocumentLinkTypes.ProposedDocument
}

export const isNotProposedDocument = (
  doc: DocumentUploaderItem | ProposedDocument
): doc is DocumentUploaderItem => {
  return doc.linkType !== ExtraDocumentLinkTypes.ProposedDocument
}
